
/* Rose & Co - Free Shipping Progress
   Supports Shopify cart page and Floria AJAX mini cart
*/

(function () {
  'use strict';

  const BAR_SELECTOR = '[data-free-shipping-progress]';
  const FOOTER_SELECTOR = '.flower-mini-cart__footer';
  const CART_SELECTOR = '.modern-cart, .ajaxcart, .flower-mini-cart__footer';

  const root = (
    window.Shopify &&
    window.Shopify.routes &&
    window.Shopify.routes.root
  ) || '/';

  let refreshTimer = null;
  let latestRequest = 0;
  let updating = false;

  function getGoal() {
    const configured = Number(window.RoseShippingGoal);

    if (Number.isFinite(configured) && configured > 0) {
      return configured;
    }

    const existing = document.querySelector(
      '.modern-cart ' + BAR_SELECTOR
    );

    if (existing) {
      const goal = Number(existing.dataset.goal);
      if (goal > 0) return goal;
    }

    return 15000;
  }

  function money(cents, currency) {
    return new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: currency || 'AUD'
    }).format(cents / 100);
  }

  function createBar() {
    const goal = getGoal();

    const bar = document.createElement('div');

    bar.className = 'rc-shipping-progress';
    bar.setAttribute('data-free-shipping-progress', '');
    bar.dataset.goal = String(goal);

    bar.setAttribute('role', 'status');
    bar.setAttribute('aria-live', 'polite');

    bar.innerHTML = `
      <div class="rc-shipping-message"
           data-shipping-message>
        Checking free shipping progress...
      </div>

      <div class="rc-shipping-track"
           data-shipping-track
           role="progressbar"
           aria-label="Free shipping progress"
           aria-valuemin="0"
           aria-valuemax="${goal / 100}"
           aria-valuenow="0">

        <div class="rc-shipping-fill"
             data-shipping-fill
             style="width:0%"></div>
      </div>

      <div class="rc-shipping-labels">
        <span data-shipping-current>$0.00</span>
        <span data-shipping-goal>${money(goal)}</span>
      </div>
    `;

    return bar;
  }

  function insertMiniCartBars() {
    let inserted = false;

    document.querySelectorAll(FOOTER_SELECTOR)
      .forEach(function (footer) {

        if (footer.querySelector(BAR_SELECTOR)) return;

        const bar = createBar();

        footer.insertBefore(bar, footer.firstChild);

        inserted = true;
      });

    return inserted;
  }

  function updateBar(bar, cart) {
    const goal = getGoal();
    const total = Number(cart.original_total_price) || 0;
    const remaining = Math.max(0, goal - total);
    const percentage = Math.min(
      100,
      Math.max(0, (total / goal) * 100)
    );

    const currency = cart.currency || 'AUD';

    const message = bar.querySelector(
      '[data-shipping-message]'
    );

    const fill = bar.querySelector(
      '[data-shipping-fill]'
    );

    const current = bar.querySelector(
      '[data-shipping-current]'
    );

    const target = bar.querySelector(
      '[data-shipping-goal]'
    );

    const track = bar.querySelector(
      '[data-shipping-track]'
    );

    if (!message || !fill || !current) return;

    bar.dataset.goal = String(goal);
    bar.classList.toggle('is-complete', remaining <= 0);

    message.textContent = remaining > 0
      ? `You're ${money(remaining, currency)} away from FREE shipping!`
      : "✓ Congratulations! You've unlocked FREE shipping!";

    fill.style.width = percentage + '%';

    current.textContent = money(total, currency);

    if (target) {
      target.textContent = money(goal, currency);
    } else {
      const labels = bar.querySelector('.rc-shipping-labels');
      if (labels && labels.lastElementChild) {
        labels.lastElementChild.textContent = money(goal, currency);
      }
    }

    if (track) {
      track.setAttribute('aria-valuemax', String(goal / 100));
      track.setAttribute(
        'aria-valuenow',
        String(Math.min(total, goal) / 100)
      );
    }
  }

  async function refresh() {
    insertMiniCartBars();

    if (!document.querySelector(BAR_SELECTOR)) return;

    const requestId = ++latestRequest;

    try {
      const response = await fetch(root + 'cart.js', {
        credentials: 'same-origin',
        cache: 'no-store'
      });

      if (!response.ok) return;

      const cart = await response.json();

      if (requestId !== latestRequest) return;

      updating = true;

      insertMiniCartBars();

      document.querySelectorAll(BAR_SELECTOR)
        .forEach(function (bar) {
          updateBar(bar, cart);
        });

      updating = false;

    } catch (error) {
      updating = false;
      console.warn('Rose shipping progress:', error);
    }
  }

  function scheduleRefresh(delay) {
    clearTimeout(refreshTimer);

    refreshTimer = setTimeout(
      refresh,
      delay === undefined ? 200 : delay
    );
  }

  const observer = new MutationObserver(function (mutations) {
    if (updating) return;

    let needsRefresh = false;

    for (const mutation of mutations) {
      const target = mutation.target;

      if (
        target.nodeType === 1 &&
        target.closest(BAR_SELECTOR)
      ) {
        continue;
      }

      if (
        target.nodeType === 3 &&
        target.parentElement &&
        target.parentElement.closest(BAR_SELECTOR)
      ) {
        continue;
      }

      if (mutation.type !== 'childList') continue;

      const nodes = [
        ...mutation.addedNodes,
        ...mutation.removedNodes
      ];

      for (const node of nodes) {
        if (node.nodeType !== 1) continue;

        if (
          node.matches(FOOTER_SELECTOR) ||
          node.querySelector(FOOTER_SELECTOR) ||
          node.matches(CART_SELECTOR) ||
          node.querySelector(CART_SELECTOR)
        ) {
          needsRefresh = true;
          break;
        }

        if (
          node.closest(CART_SELECTOR) &&
          !node.closest(BAR_SELECTOR)
        ) {
          needsRefresh = true;
          break;
        }
      }

      if (needsRefresh) break;
    }

    if (needsRefresh) {
      insertMiniCartBars();
      scheduleRefresh(250);
    }
  });

  function init() {
    insertMiniCartBars();

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    refresh();

    document.addEventListener('click', function (event) {
      const target = event.target;

      if (!(target instanceof Element)) return;

      if (
        target.closest(
          '.ajaxcart__qty-adjust, .remove-product, ' +
          '.modern-cart__quantity, .modern-cart__remove'
        )
      ) {
        scheduleRefresh(650);
        setTimeout(refresh, 1400);
      }
    }, true);

    document.addEventListener('change', function (event) {
      if (
        event.target.matches(
          '.ajaxcart__qty-num, [data-cart-quantity-input]'
        )
      ) {
        scheduleRefresh(650);
        setTimeout(refresh, 1400);
      }
    }, true);

    document.addEventListener(
      'shopify:section:load',
      function () {
        insertMiniCartBars();
        scheduleRefresh();
      }
    );

    document.addEventListener(
      'visibilitychange',
      function () {
        if (!document.hidden) scheduleRefresh();
      }
    );

    window.addEventListener('pageshow', function () {
      scheduleRefresh();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.RoseShippingProgress = {
    refresh: refresh
  };

})();
